import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Base } from '../../../../types/Base.type';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll(){
    return this.httpClient.get<Base[]>(`${this.configService.getApiUrl()}/base`);
  }

  post(base: Base){
    return this.httpClient.post<Base>(`${this.configService.getApiUrl()}/base`, base);
  }

  delete(id: string){
    return this.httpClient.delete(`${this.configService.getApiUrl()}/base/` + id);
  }

  put(base: Base){
    return this.httpClient.put(`${this.configService.getApiUrl()}/base`, base);
  }
}
